import React, { Component, Fragment } from 'react';
import { Button, Form, Header, Loader, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import {
    fetchMunicipalities,
    fetchCantons,
    fetchEntities,
    fetchCountries,
    fetchPropertyTypes,
    fetchMunicipalCadastres,
} from '../Lookups/util';
import { formatListForDropdownOptions } from '../util/util';
import { fetchFaculties } from '../../Lookups/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

class PropertyForm extends Component {
    constructor(props) {
        super(props);

        const oup = props.organizationalUnitProperty || {};
        const prop = oup.property || {};
        const address = prop.address || {};
        const place = address.place || {};

        this.state = {
            organizationalUnitId: oup.organizationalUnit ? oup.organizationalUnit.id : (props.organizationalUnitId || null),

            // Property fields
            name: prop.name || '',
            propertyType: prop.propertyType ? prop.propertyType.id : null,

            // Address fields
            street: address.street || '',
            placeName: place.name || '',
            municipality: place.municipality ? place.municipality.id : null,
            canton: place.canton ? place.canton.id : null,
            entity: place.entity ? place.entity.id : null,
            country: place.country ? place.country.id : null,

            disabledMunicipality: !place.municipality,
            disabledCanton: !place.canton,
            disabledEntity: !place.entity,

            // Land registry
            landRegistryArea: prop.landRegistryArea || '',
            landRegistryEntryNumber: prop.landRegistryEntryNumber || '',
            landRegistryMunicipalCadastre: prop.landRegistryMunicipalCadastre ? prop.landRegistryMunicipalCadastre.id : null,
            encumbrances: prop.encumbrances || '',
            bListNotes: prop.bListNotes || '',
            landRegistryRightsScopeNotes: prop.landRegistryRightsScopeNotes || '',

            // Possession
            possessionSheetNumber: prop.possessionSheetNumber || '',
            possessionMunicipalCadastre: prop.possessionMunicipalCadastre ? prop.possessionMunicipalCadastre.id : null,
            possessionArea: prop.possessionArea || '',
            possessionRightsScopeNotes: prop.possessionRightsScopeNotes || '',

            // Harmonization
            harmonized: !!prop.harmonized,

            // Accounting
            acquisitionValue: prop.acquisitionValue || '',
            valueAdjustment: prop.valueAdjustment || '',
            bookValue: prop.bookValue || '',
            jointInvestmentRightsScopeNotes: prop.jointInvestmentRightsScopeNotes || '',

            // Notes
            notes: prop.notes || '',
            additionalNotes: prop.additionalNotes || '',
            ownershipEvidence: prop.ownershipEvidence || '',

            // Edit metadata
            oupId: oup.id || null,
            oupOptLock: oup.optLock || null,
            propertyId: prop.id || null,
            propertyOptLock: prop.optLock || null,

            // UI
            saving: false,
            loadingOptions: true,
            errors: {},

            // Lookup options
            organizationalUnitsOptions: [],
            propertyTypesOptions: [],
            municipalCadastresOptions: [],
            municipalitiesOptions: [],
            cantonsOptions: [],
            entitiesOptions: [],
            countriesOptions: [],
            allowedMunicipalities: [],
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleMunicipalityChange = this.handleMunicipalityChange.bind(this);
        this.handleCantonChange = this.handleCantonChange.bind(this);
        this.handleEntityChange = this.handleEntityChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
    }

    componentDidMount() {
        axios.all([
            fetchFaculties(),
            fetchPropertyTypes(),
            fetchMunicipalCadastres(),
            fetchMunicipalities(),
            fetchCantons(),
            fetchEntities(),
            fetchCountries(),
        ])
            .then(axios.spread((orgUnitsRes, propertyTypesRes, municipalCadastresRes, municipalitiesRes, cantonsRes, entitiesRes, countriesRes) => {
                const orgUnits = formatListForDropdownOptions(orgUnitsRes.data);
                const propertyTypes = formatListForDropdownOptions(propertyTypesRes.data);
                const municipalCadastres = formatListForDropdownOptions(municipalCadastresRes.data);
                const municipalities = formatListForDropdownOptions(municipalitiesRes.data);
                const cantons = formatListForDropdownOptions(cantonsRes.data);
                const entities = formatListForDropdownOptions(entitiesRes.data);
                const countries = formatListForDropdownOptions(countriesRes.data);

                this.setState({
                    organizationalUnitsOptions: orgUnits,
                    propertyTypesOptions: propertyTypes,
                    municipalCadastresOptions: municipalCadastres,
                    municipalitiesOptions: municipalities,
                    cantonsOptions: cantons,
                    entitiesOptions: entities,
                    countriesOptions: countries,
                    allowedMunicipalities: municipalities,
                    loadingOptions: false,
                });
            }))
            .catch(() => {
                this.setState({ loadingOptions: false });
            });
    }

    handleInputChange(event, data) {
        if (data && data.name !== undefined) {
            this.setState({ [data.name]: data.value });
        } else {
            const {
                name,
                value
            } = event.target;
            this.setState({ [name]: value });
        }
    }

    handleMunicipalityChange(e, { value }) {
        const municipality = this.state.municipalitiesOptions.find(el => el.id === value);
        this.setState({
            municipality: value,
            canton: municipality && municipality.canton ? municipality.canton.id : null,
            entity: municipality && municipality.entity ? municipality.entity.id : null,
            country: municipality && municipality.country ? municipality.country.id : null,
        });
    }

    handleCantonChange(e, { value }) {
        const entity = this.state.entitiesOptions.find(el => el.name === 'Federacija Bosne i Hercegovine');
        const country = this.state.countriesOptions.find(el => el.name === 'Bosna i Hercegovina');
        this.setState({
            allowedMunicipalities: this.state.municipalitiesOptions.filter(el => el.canton && el.canton.id === value),
            canton: value,
            municipality: null,
            entity: entity ? entity.id : null,
            country: country ? country.id : null,
        });
    }

    handleEntityChange(e, { value }) {
        let disabledCanton = false;
        let disabledMunicipality = false;

        if (value === 3) {
            disabledCanton = true;
            disabledMunicipality = true;
        } else if (value === 2) {
            disabledCanton = true;
        }

        const country = this.state.countriesOptions.find(el => el.name === 'Bosna i Hercegovina');

        this.setState({
            entity: value,
            canton: null,
            municipality: null,
            country: country ? country.id : null,
            disabledCanton,
            disabledMunicipality,
            allowedMunicipalities: value
                ? this.state.municipalitiesOptions.filter(el => el.entity && el.entity.id === value)
                : this.state.municipalitiesOptions,
        });
    }

    handleCountryChange(e, { value }) {
        let disabledEntity = false;
        let disabledCanton = false;
        let disabledMunicipality = false;

        if (value !== 22) {
            disabledEntity = true;
            disabledCanton = true;
            disabledMunicipality = true;
        }

        this.setState({
            country: value,
            disabledEntity,
            disabledCanton,
            disabledMunicipality,
            municipality: null,
            entity: null,
            canton: null,
            allowedMunicipalities: this.state.municipalitiesOptions,
        });
    }

    handleSubmit = () => {
        const isEditing = !!this.props.organizationalUnitProperty;
        const {
            organizationalUnitId,
            name,
            propertyType,
            street,
            placeName,
            municipality,
            canton,
            entity,
            country,
            landRegistryArea,
            landRegistryEntryNumber,
            landRegistryMunicipalCadastre,
            encumbrances,
            bListNotes,
            landRegistryRightsScopeNotes,
            possessionSheetNumber,
            possessionMunicipalCadastre,
            possessionArea,
            possessionRightsScopeNotes,
            harmonized,
            ownershipEvidence,
            jointInvestmentRightsScopeNotes,
            acquisitionValue,
            valueAdjustment,
            bookValue,
            notes,
            additionalNotes,
            oupId,
            oupOptLock,
            propertyId,
            propertyOptLock,
        } = this.state;

        // Validation
        const errors = {
            nameErr: !name,
            propertyTypeErr: !propertyType,
            streetErr: !street,
            placeErr: !placeName,
            countryErr: !country,
            organizationalUnitErr: !organizationalUnitId,
        };

        if (Object.values(errors)
            .some(e => e)) {
            this.setState({ errors });
            toast('Nisu sva obavezna polja popunjena!');
            return;
        }

        this.setState({ saving: true }, () => {
            const property = {
                name,
                propertyType: propertyType ? { id: propertyType } : null,
                address: {
                    street,
                    place: {
                        name: placeName,
                        municipality: municipality ? { id: municipality } : null,
                        canton: canton ? { id: canton } : null,
                        entity: entity ? { id: entity } : null,
                        country: country ? { id: country } : null,
                    },
                },
                landRegistryArea: landRegistryArea || null,
                landRegistryEntryNumber: landRegistryEntryNumber || null,
                landRegistryMunicipalCadastre: landRegistryMunicipalCadastre ? { id: landRegistryMunicipalCadastre } : null,
                encumbrances: encumbrances || null,
                bListNotes: bListNotes || null,
                landRegistryRightsScopeNotes: landRegistryRightsScopeNotes || null,
                possessionSheetNumber: possessionSheetNumber || null,
                possessionMunicipalCadastre: possessionMunicipalCadastre ? { id: possessionMunicipalCadastre } : null,
                possessionArea: possessionArea || null,
                possessionRightsScopeNotes: possessionRightsScopeNotes || null,
                harmonized: harmonized || false,
                ownershipEvidence: ownershipEvidence || null,
                jointInvestmentRightsScopeNotes: jointInvestmentRightsScopeNotes || null,
                acquisitionValue: acquisitionValue || null,
                valueAdjustment: valueAdjustment || null,
                bookValue: bookValue || null,
                notes: notes || null,
                additionalNotes: additionalNotes || null,
            };

            const body = isEditing
                ? {
                    id: oupId,
                    optLock: oupOptLock,
                    organizationalUnit: { id: organizationalUnitId },
                    property: {
                        ...property,
                        id: propertyId,
                        optLock: propertyOptLock
                    },
                }
                : {
                    organizationalUnit: { id: organizationalUnitId },
                    property,
                };

            const apiCall = isEditing
                ? axios.put('/assets/organizational-unit-properties/', body)
                : axios.post('/assets/organizational-unit-properties/', body);

            apiCall
                .then(() => {
                    this.setState({ saving: false });
                    this.props.onCloseForm();
                    this.props.onRefreshData();
                    toast(isEditing ? 'Uspješno ste izmijenili imovinu!' : 'Uspješno ste dodali imovinu!');
                })
                .catch(() => {
                    this.setState({ saving: false });
                    toast(isEditing
                        ? 'Došlo je do greške pri izmjeni imovine.'
                        : 'Došlo je do greške pri dodavanju imovine!');
                });
        });
    };

    render() {
        const {
            loadingOptions,
            saving,
            errors
        } = this.state;
        const isEditing = !!this.props.organizationalUnitProperty;

        if (loadingOptions) {
            return (
                <div style={{
                    paddingTop: '100px',
                    paddingBottom: '100px'
                }}>
                    <Loader active inline="centered"/>
                </div>
            );
        }

        return (
            <Segment clearing padded>
                <Form noValidate>
                    {/* Opći podaci */}
                    <Header as="h3"><Header.Content>Opći podaci</Header.Content></Header>
                    <Form.Group widths="equal">
                        {this.props.showOrganizationalUnitDropdown && (
                            <Form.Dropdown
                                clearable
                                label="Članica"
                                placeholder="Članica"
                                value={this.state.organizationalUnitId}
                                onChange={this.handleInputChange}
                                name="organizationalUnitId"
                                options={this.state.organizationalUnitsOptions}
                                search
                                fluid
                                required
                                error={errors.organizationalUnitErr}
                                selection
                            />
                        )}
                        <Form.Field
                            control="input"
                            label="Naziv imovine"
                            name="name"
                            value={this.state.name}
                            onChange={this.handleInputChange}
                            placeholder="Unesite naziv imovine"
                            required
                            error={errors.nameErr}
                        />
                        <Form.Dropdown
                            clearable
                            label="Vrsta nepokretnosti"
                            placeholder="Tip imovine"
                            value={this.state.propertyType}
                            name="propertyType"
                            onChange={this.handleInputChange}
                            options={this.state.propertyTypesOptions}
                            search
                            fluid
                            required
                            error={errors.propertyTypeErr}
                            selection
                        />
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Dropdown
                            clearable
                            label="Država"
                            placeholder="Država"
                            value={this.state.country}
                            name="country"
                            onChange={this.handleCountryChange}
                            options={this.state.countriesOptions}
                            search
                            fluid
                            required
                            error={errors.countryErr}
                            selection
                        />
                        <Form.Dropdown
                            clearable
                            label="Entitet"
                            placeholder="Entitet"
                            value={this.state.entity}
                            name="entity"
                            onChange={this.handleEntityChange}
                            options={this.state.entitiesOptions}
                            search
                            fluid
                            disabled={this.state.disabledEntity}
                            required={!this.state.disabledEntity}
                            error={this.state.entityError}
                            selection
                        />
                        <Form.Dropdown
                            clearable
                            label="Kanton"
                            placeholder="Kanton"
                            value={this.state.canton}
                            name="canton"
                            onChange={this.handleCantonChange}
                            options={this.state.cantonsOptions}
                            search
                            fluid
                            disabled={this.state.disabledCanton}
                            required={!this.state.disabledCanton}
                            error={this.state.cantonError}
                            selection
                        />
                        <Form.Dropdown
                            clearable
                            label="Opština"
                            placeholder="Opština"
                            value={this.state.municipality}
                            name="municipality"
                            onChange={this.handleMunicipalityChange}
                            options={this.state.allowedMunicipalities}
                            search
                            fluid
                            disabled={this.state.disabledMunicipality}
                            required={!this.state.disabledMunicipality}
                            error={this.state.municipalityError}
                            selection
                        />
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field
                            control="input"
                            label="Ulica"
                            name="street"
                            value={this.state.street}
                            onChange={this.handleInputChange}
                            placeholder="Unesite ulicu"
                            required
                            error={errors.streetErr}
                        />
                        <Form.Field
                            control="input"
                            label="Mjesto"
                            name="placeName"
                            value={this.state.placeName}
                            onChange={this.handleInputChange}
                            placeholder="Unesite naziv mjesta"
                            required
                            error={errors.placeErr}
                        />
                    </Form.Group>
                    {/* Zemljišno-knjižni podaci */}
                    <Header as="h3"><Header.Content>Zemljišno-knjižni podaci</Header.Content></Header>
                    <Form.Group widths="equal">
                        <Form.Field
                            control="input"
                            label="Površina (m²)"
                            name="landRegistryArea"
                            type="number"
                            value={this.state.landRegistryArea}
                            onChange={this.handleInputChange}
                            placeholder="Površina"
                        />
                        <Form.Field
                            control="input"
                            label="Broj ZK uloška"
                            name="landRegistryEntryNumber"
                            type="number"
                            value={this.state.landRegistryEntryNumber}
                            onChange={this.handleInputChange}
                            placeholder="Broj uloška"
                        />
                        <Form.Dropdown
                            clearable
                            label="Opštinski katastar (ZK)"
                            placeholder="Opštinski katastar"
                            value={this.state.landRegistryMunicipalCadastre}
                            name="landRegistryMunicipalCadastre"
                            onChange={this.handleInputChange}
                            options={this.state.municipalCadastresOptions}
                            search
                            fluid
                            selection
                        />
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field
                            control="textarea"
                            label="Tereti"
                            name="encumbrances"
                            value={this.state.encumbrances}
                            onChange={this.handleInputChange}
                            placeholder="Tereti"
                        />
                        <Form.Field
                            control="textarea"
                            label='Zabilježbe iz "B" lista'
                            name="bListNotes"
                            value={this.state.bListNotes}
                            onChange={this.handleInputChange}
                            placeholder="Napomene"
                        />
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field
                            control="input"
                            label="Obim prava (ZK)"
                            name="landRegistryRightsScopeNotes"
                            value={this.state.landRegistryRightsScopeNotes}
                            onChange={this.handleInputChange}
                            placeholder="Obim prava (ZK)"
                        />
                    </Form.Group>

                    {/* Katastarski/posjedovni podaci */}
                    <Header as="h3"><Header.Content>Katastarski/posjedovni podaci</Header.Content></Header>
                    <Form.Group widths="equal">
                        <Form.Field
                            control="input"
                            label="Broj posjedovnog lista / Kopije katastarskog plana "
                            name="possessionSheetNumber"
                            type="number"
                            value={this.state.possessionSheetNumber}
                            onChange={this.handleInputChange}
                            placeholder="Broj lista"
                        />
                        <Form.Dropdown
                            clearable
                            label="Opštinski katastar (KP)"
                            placeholder="Opštinski katastar"
                            value={this.state.possessionMunicipalCadastre}
                            name="possessionMunicipalCadastre"
                            onChange={this.handleInputChange}
                            options={this.state.municipalCadastresOptions}
                            search
                            fluid
                            selection
                        />
                        <Form.Field
                            control="input"
                            label="Površina (m²)"
                            name="possessionArea"
                            type="number"
                            value={this.state.possessionArea}
                            onChange={this.handleInputChange}
                            placeholder="Površina"
                        />
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field
                            control="input"
                            label="Obim prava (KP)"
                            name="possessionRightsScopeNotes"
                            value={this.state.possessionRightsScopeNotes}
                            onChange={this.handleInputChange}
                            placeholder="Obim prava (KP)"
                        />
                    </Form.Group>

                    {/* Usklađenost */}
                    <Header as="h3"><Header.Content>Usklađenost</Header.Content></Header>
                    <Form.Checkbox
                        toggle
                        label="Usklađeno"
                        checked={this.state.harmonized}
                        onChange={(e, { checked }) => this.setState({ harmonized: checked })}
                    />

                    {/* Dokazi */}
                    <Header as="h3"><Header.Content>Dokazi</Header.Content></Header>
                    <Form.Field
                        control="textarea"
                        label="Dokazi o vlasništvu i/ili posjedu"
                        name="ownershipEvidence"
                        value={this.state.ownershipEvidence}
                        onChange={this.handleInputChange}
                        placeholder="Dokazi o vlasništvu"
                    />

                    {/* Knjigovodstveni podaci */}
                    <Header as="h3"><Header.Content>Knjigovodstveni podaci</Header.Content></Header>
                    <Form.Group widths="equal">
                        <Form.Field
                            control="input"
                            label="Nabavna vrijednost"
                            name="acquisitionValue"
                            type="number"
                            value={this.state.acquisitionValue}
                            onChange={this.handleInputChange}
                            placeholder="Nabavna vrijednost (u BAM)"
                        />
                        <Form.Field
                            control="input"
                            label="Ispravka vrijednosti (ispravka/otpis prethodnih godina)"
                            name="valueAdjustment"
                            type="number"
                            value={this.state.valueAdjustment}
                            onChange={this.handleInputChange}
                            placeholder="Ispravka vrijednosti (u BAM)"
                        />
                        <Form.Field
                            control="input"
                            label="Knjigovodstvena vrijednost (procijenjena vrijednost)"
                            name="bookValue"
                            type="number"
                            value={this.state.bookValue}
                            onChange={this.handleInputChange}
                            placeholder="Knjigovodstvena vrijednost (u BAM)"
                        />
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field
                            control="input"
                            label="Obim prava (zajednička ulaganja)"
                            name="jointInvestmentRightsScopeNotes"
                            value={this.state.jointInvestmentRightsScopeNotes}
                            onChange={this.handleInputChange}
                            placeholder="Obim prava (zajednička ulaganja)"
                        />
                    </Form.Group>

                    {/* Napomene */}
                    <Header as="h3"><Header.Content>Napomene</Header.Content></Header>
                    <Form.Group widths="equal">
                        <Form.Field
                            control="textarea"
                            label="Napomene"
                            name="notes"
                            value={this.state.notes}
                            onChange={this.handleInputChange}
                            placeholder="Napomene"
                        />
                        <Form.Field
                            control="textarea"
                            label="Dodatne napomene"
                            name="additionalNotes"
                            value={this.state.additionalNotes}
                            onChange={this.handleInputChange}
                            placeholder="Dodatne napomene"
                        />
                    </Form.Group>

                    {/* Actions */}
                    <Button floated="right" basic color="blue" disabled={saving} onClick={this.props.onCloseForm}>
                        Odustani
                    </Button>
                    <Button floated="right" color="blue" loading={saving} onClick={this.handleSubmit}>
                        {isEditing ? 'Sačuvaj izmjene' : 'Dodaj'}
                    </Button>
                </Form>
                <ToastContainer hideProgressBar/>
            </Segment>
        );
    }
}

export default PropertyForm;



// WEBPACK FOOTER //
// ./src/views/Assets/Property/PropertyForm.js